import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Route,
  Navigate,
  Routes as RoutesDom,
  useLocation,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { RouteConstants } from "../constants";
import { logout } from "../store/slices/authSlice";
import { LoginLocal, Login } from "../components/features/login";
import ForgotPassword from "../components/features/forgotPassword";
import ResetPassword from "../components/features/resetPassword";
import Home from "../components/features/home";
import SetPassword from "../components/features/setPassword";
import OtpLogin from "../components/features/otpLogin";
import { useMountEffect, usePrevious } from "primereact/hooks";
import * as GlobalHelper from "../helpers/GlobalHelper";

const Routes = ({ auth, logout }) => {
  const [searchParams] = useSearchParams();
  const [redirectPath, setRedirectPath] = useState(null);
  const previousRefreshToken = usePrevious(auth?.session?.refreshToken);
  const navigate = useNavigate();
  const location = useLocation();
  const isRootDomain = GlobalHelper.CheckIfRootDomain(
    window.location.hostname.split(".")[0]
  );

  useMountEffect(() => {
    if (searchParams.get("params") && auth?.session?.refreshToken) {
      logout();
      setRedirectPath(location);
    }
  });

  useEffect(() => {
    if (previousRefreshToken && !auth?.session?.refreshToken) {
      if (redirectPath) {
        navigate(redirectPath, { replace: true });
        setRedirectPath(null);
      } else {
        navigate(RouteConstants.APP_ROUTE_LOGIN, { replace: true });
      }
    }
  }, [
    auth?.session?.refreshToken,
    previousRefreshToken,
    navigate,
    redirectPath,
  ]);

  if (!auth?.session?.refreshToken) {
    return (
      <RoutesDom>
        <Route
          exact
          path={RouteConstants.APP_ROUTE_FORGOT_PASSWORD}
          element={<ForgotPassword />}
        />
        <Route
          exact
          path={RouteConstants.APP_ROUTE_RESET_PASSWORD}
          element={<ResetPassword />}
        />
        <Route
          exact
          path={RouteConstants.APP_ROUTE_SET_PASSWORD}
          element={<SetPassword />}
        />
        <Route
          exact
          path={RouteConstants.APP_ROUTE_LOGIN_LOCAL}
          element={<LoginLocal />}
        />
        {(!isRootDomain && (
          <Route
            exact
            path={RouteConstants.APP_ROUTE_LOGIN}
            element={<Login />}
          />
        )) ||
          null}
        <Route
          exact
          path={RouteConstants.APP_ROUTE_OTP}
          element={<OtpLogin />}
        />
        <Route
          index
          path="/*"
          element={
            <Navigate
              to={
                isRootDomain
                  ? RouteConstants.APP_ROUTE_LOGIN_LOCAL
                  : RouteConstants.APP_ROUTE_LOGIN
              }
              replace
            />
          }
        />
      </RoutesDom>
    );
  } else {
    return (
      <RoutesDom>
        <Route path="/*" element={<Home />} />
      </RoutesDom>
    );
  }
};

Routes.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
